import { useEffect, useRef } from 'react';

import { SESSION_EXPIRED_ERROR } from '@/assets/AppConstants';
import { useAppContext } from '@/contexts/app';
import { useUserContext } from '@/contexts/user';
import { onSessionExpired } from '@/interceptors/sessionExpiry';

const SessionErrorForwarder = () => {
  const { handleRequestStatus } = useAppContext();
  const { userIsLogged } = useUserContext();

  const userIsLoggedRef = useRef(userIsLogged);
  userIsLoggedRef.current = userIsLogged;

  useEffect(() => onSessionExpired(() => {
    if (userIsLoggedRef.current()) handleRequestStatus(SESSION_EXPIRED_ERROR);
  }), [handleRequestStatus]);

  return null;
};

export default SessionErrorForwarder;
